export enum Period {
    All = 'all',
    Today = 'today',
    Tomorrow = 'tomorrow',
    Yesterday = 'yesterday',
    PreviousWeek = 'prev-week',
    CurrentWeek = 'current-week',
    NextWeek = 'next-week',
    PreviousMonth = 'prev-month',
    CurrentMonth = 'current-month',
    NextMonth = 'next-month',
    PreviousQrt = 'prev-qrt',
    CurrentQrt = 'current-qrt',
    Ytd = 'ytd',
    CurrentYear = 'current-year',
    PreviousFy = 'prev-fy',
    CurrentFy = 'current-fy',
    Past = 'past',
    Future = 'future',
}

export enum StatsRange {
    Today = 'today',
    Tomorrow = 'tomorrow',
    CurrentWeek = 'current-week',
    PreviousWeek = 'prev-week',
    NextWeek = 'next-week',
    CurrentMonth = 'current-month',
    CurrentYear = 'current-year',
    All = 'all',
}

export enum StatsBreakdown {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year',
    All = 'all',
}
